import {
  AgentFlow,
  AgentMessageViewModel,
  AgentTab,
  AgentThread,
  AgentUiComponent,
  AgentUpload,
} from '../models';

export class OpenAgentPanel {
  static readonly type = '[Agent] Open Panel';
}

export class NewChat {
  static readonly type = '[Agent] New Chat';
}

export class CloseAgentPanel {
  static readonly type = '[Agent] Close Panel';
}

export class SetActiveTab {
  static readonly type = '[Agent] Set Active Tab';
  constructor(public tab: AgentTab) {}
}

export class SetAgentFlow {
  static readonly type = '[Agent] Set Flow';
  constructor(public flow: AgentFlow) {}
}

export class SendUserMessage {
  static readonly type = '[Agent] Send User Message';
  constructor(
    public text: string,
    public file?: File,
    public orgId?: string,
  ) {}
}

export class ReceiveAgentMessage {
  static readonly type = '[Agent] Receive Agent Message';
  constructor(public message: AgentMessageViewModel) {}
}

export class SetAgentTyping {
  static readonly type = '[Agent] Set Typing';
  constructor(public isTyping: boolean) {}
}

export class AddUpload {
  static readonly type = '[Agent] Add Upload';
  constructor(public upload: AgentUpload) {}
}

export class LoadHistory {
  static readonly type = '[Agent] Load History';
}

export class LoadMoreHistory {
  static readonly type = '[Agent] Load More History';
}

export class SetHistory {
  static readonly type = '[Agent] Set History';
  constructor(public threads: AgentThread[]) {}
}

export class AppendHistory {
  static readonly type = '[Agent] Append History';
  constructor(
    public threads: AgentThread[],
    public hasMore: boolean,
  ) {}
}

export class SelectThread {
  static readonly type = '[Agent] Select Thread';
  constructor(public threadId: string) {}
}

export class DeleteThread {
  static readonly type = '[Agent] Delete Thread';
  constructor(public threadId: string) {}
}

export class PinThread {
  static readonly type = '[Agent] Pin Thread';
  constructor(public threadId: string) {}
}

export class DownloadUpload {
  static readonly type = '[Agent] Download Upload';
  constructor(public upload: AgentUpload) {}
}

export class AppendStreamToken {
  static readonly type = '[Agent] Append Stream Token';
  constructor(public token: string) {}
}

export class FinalizeStreamedMessage {
  static readonly type = '[Agent] Finalize Streamed Message';
  constructor(
    public reply: string,
    public threadId: string,
    public components?: AgentUiComponent[],
    public timestamp?: string,
  ) {}
}
